<div class="side-nav" *ngIf="pages$ | async as _pages">
  <div class="side-nav__wrapper" [ngClass]="{'slide-hide':openChildNav !== false}">
    <div class="site-logo">
      <a [core-analytics]="{action: 'Home', category: 'SIDE-NAV'}" class="site-logo__link"
         routerLink="/"
      >
        <img [src]="logoUrl | cdn" alt="{{getSiteName()}}" class="site-logo__image">
      </a>
    </div>

    <core-search-form *ngIf="searchEnabled" [autoFocus]="false" class="core-search-form--sidenav"></core-search-form>

    <button (click)="hamburger = !hamburger; menuStateCheck(!hamburger)" [core-analytics]="{action: 'Toggle menu', category: 'SIDE-NAV'}"
            class="hamburger hamburger--squeeze"
            type="button"
            [ngClass]="{'is-active':hamburger}" aria-label="Hamburger menu">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
    </button>

    <!-- Not adding to DOM if we're showing the responsive menu -->
    <ng-container *ngIf="!isMobileNav">
      <nav class="side-nav__menu" aria-label="Main navigation">
        <ul class="side-nav__menu-list">
          <ng-container *ngFor="let page of _pages | orderBy:['displayOrder'] trackBy: trackByFn">
            <li class="side-nav__menu-item"
                *ngIf="showInMenu(page, 'no-child')"
                [ngClass]="{'nav-item--posts' : isDemoModeAndPostsLink(page)}">
              <a class="side-nav__menu-link" [ngClass]="{'active': isCurrentPage(page)}"
                 [core-analytics]="{action: page.url, category: 'SIDE-NAV'}"
                 [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                 *ngIf="page.children.length === 0">
                {{page.name}}
              </a>
              <a (click)="childNav(page)" class="side-nav__menu-link side-nav__menu-link-has-children"
                 href="javascript:void(0);"
                 [core-analytics]="{action: 'Toggle ' + page.name, category: 'SIDE-NAV'}"
                 *ngIf="page.children.length > 0">
                {{page.name}}
              </a>
            </li>

            <!-- ** REMOVE <li> FOR CLIENT BUILD **
            Split out <li> for 'posts' demo toggle purposes only. This can be removed for a client build -->
            <li class="side-nav__menu-item"
                *ngIf="isDemoMode && page.url === 'posts' && postsEnabled">
              <a class="side-nav__menu-link" [ngClass]="{'active': isCurrentPage(page)}"
                 [core-analytics]="{action: page.url, category: 'SIDE-NAV'}"
                 [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                 *ngIf="page.children.length === 0" aria-current="page"
                 id="{{page.url}}"
                 (click)="childNav(page.url)"
                 href="javascript:void(0)">
                {{page.name}}
              </a>
            </li>

          </ng-container>
        </ul>
      </nav>
    </ng-container>

    <core-side-nav-footer></core-side-nav-footer>

  </div>

  <div class="side-nav__children" [ngClass]="{'active':openChildNav !== false}">
    <h3 *ngIf="openChildNav.name" class="side-nav__children-heading">
      <a class="side-nav__children-back-link" href="javascript:void(0)"
         [core-analytics]="{action: 'Back', category: 'SIDE-NAV'}"
         (click)="resetChildNav()"><span></span>{{'Back' | translate}}</a>
    </h3>
    <ul class="side-nav__child-menu-list">
      <ng-container *ngFor="let page of openChildNav.children | orderBy:['displayOrder', 'name'] trackBy: trackByFn">
        <li class="side-nav__child-menu-item"
            *ngIf="page.meta.showInMenu == 'true' || page.meta.showInMenu == '\'true\'' || page.meta.showInMenu == true">
          <a class="side-nav__child-menu-link"
             [core-analytics]="{action: page.url, category: 'SIDE-NAV'}"
             [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
             [ngClass]="{'active': isCurrentPage(page)}">{{page.name}}</a>
        </li>
      </ng-container>
    </ul>
  </div>

  <!-- Not adding to DOM if we're showing the desktop sidenav menu -->
  <div *ngIf="isMobileNav" class="mobile-nav" [ngClass]="{'mobile-nav--active': hamburger}">
    <div class="mobile-nav__wrapper">
      <core-search *ngIf="searchEnabled" (closeSidenavHamburgerNav)="hamburger = !hamburger"></core-search>
      <div class="side-nav__wrapper" [ngClass]="{'active':openChildNav !== false}">
        <!-- If search is needed, uncomment this out and ensure /search page in Core is not DRAFT -->
        <!-- <core-search (closeSidenavHamburgerNav)="closeResponsiveMenuOnSearch($event)"></core-search> -->
        <nav class="side-nav__menu" aria-label="Mobile navigation">
          <ul class="side-nav__menu-list">
            <ng-container *ngFor="let page of _pages | orderBy:['displayOrder'] trackBy: trackByFn">
              <li class="side-nav__menu-item"
                  *ngIf="page.meta.showInMenu == 'true' || page.meta.showInMenu == '\'true\'' || page.meta.showInMenu == true || page.name === 'home'">
                <a class="side-nav__menu-link" (click)="hamburger = !hamburger"
                   [core-analytics]="{action: page.url, category: 'SIDE-NAV'}"
                   [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                   *ngIf="page.children.length === 0"
                   [ngClass]="{'active': isCurrentPage(page)}">
                  {{page.name}}
                </a>
                <a (click)="childNav(page)" [core-analytics]="{action: 'Toggle ' + page.name, category: 'SIDE-NAV'}"
                   class="side-nav__menu-link side-nav__menu-link-has-children"
                   href="javascript:void(0);"
                   *ngIf="page.children.length > 0">
                  {{page.name}}
                </a>
              </li>
            </ng-container>
          </ul>
        </nav>

        <core-side-nav-footer></core-side-nav-footer>

      </div>

      <div class="side-nav__children" [ngClass]="{'active':openChildNav !== false, 'search-on': searchEnabled}">
        <h3 class="side-nav__children-heading" *ngIf="openChildNav.name">
          <a class="side-nav__children-back-link" href="javascript:void(0)"
             [core-analytics]="{action: 'Back', category: 'SIDE-NAV'}"
             (click)="resetChildNav()"><span></span>{{'Back' | translate}}</a>
        </h3>
        <ul class="side-nav__children-list">
          <ng-container *ngFor="let page of openChildNav.children trackBy: trackByFn">
            <li class="side-nav__children-item"
                *ngIf="page.meta.showInMenu == 'true' || page.meta.showInMenu == '\'true\'' || page.meta.showInMenu == true">
              <a class="side-nav__children-link" (click)="resetChildNav(); hamburger = !hamburger"
                 [core-analytics]="{action: page.url, category: 'SIDE-NAV'}"
                 [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url">{{page.name}}</a>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>
